import { isNil, setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./ItemContent.module.less";
import { never } from "client_legacy/ndaw/errors";
import { Badge } from "client/Components";

export type ItemContentProps = {
	title: string;
	isActive: boolean;
	newItemsIndicator?: number | boolean;
};

export const ItemContent = (props: ItemContentProps): ReactElement => {
	const {
		title,
		isActive,
		newItemsIndicator
	} = props;

	const renderNewItemsIndicator = (): ReactElement | null => {
		if (isNil(newItemsIndicator)) {
			return null;
		}

		if (typeof newItemsIndicator === "number") {
			if (newItemsIndicator === 0) {
				return null;
			}

			return (
				<Badge
					amount={newItemsIndicator}
					trackingId="new-items-count"
					isActive={isActive}
				/>
			);
		}

		if (typeof newItemsIndicator === "boolean") {
			if (!newItemsIndicator) {
				return null;
			}

			return (
				<div
					{...setTrackingId("new-items-indicator")}
					className={styles.indicator}
				/>
			);
		}

		never(newItemsIndicator);
	};

	return (
		<div className={styles.itemContent}>
			<div
				{...setTrackingId("title")}
				className={styles.title}
			>
				{title}
			</div>
			{renderNewItemsIndicator()}
		</div>
	);
};
ItemContent.displayName = "ItemContent";